import { useEffect, useRef } from 'react';

import { setAttribution } from './attributionStore';
import { parseAttribution } from './parseAttribution';
import { TRACKED_PARAM_KEYS } from './types';

type SearchParams = Record<string, string | string[] | undefined>;

const buildTrackedParamsKey = (params: SearchParams): string =>
  TRACKED_PARAM_KEYS.map((key) => {
    const value = params[key];
    if (Array.isArray(value)) return value[0] ?? '';
    return value ?? '';
  }).join('|');

export const useCaptureAttribution = (params: SearchParams): void => {
  const trackedKey = buildTrackedParamsKey(params);
  const lastProcessedKey = useRef<string | null>(null);

  useEffect(() => {
    if (lastProcessedKey.current === trackedKey) return;
    lastProcessedKey.current = trackedKey;
    const parsed = parseAttribution(params);
    if (parsed) setAttribution(parsed);
  });
};
